<template>
    <div>
        <OverlayModal
                closeText="Close"
                @modalClosed="closeModal">

            <div class="search-input-holder">
                <input type="text" class="form-control" v-model="searchQuery" id="search-input" autocomplete="off" />
                <a href="javascript:;" class="clear-search-btn" v-on:click="clearSearch()">Clear</a>
                <span class="library-counter">{{ devices.length }} Devices</span>
            </div>

            <table class="results" >
                <tr>
                    <th>Nickname</th>
                    <th>Version</th>
                    <th>IP</th>
                    <th>Last Connect</th>
                    <th></th>
                </tr>

                <tr v-for="device of filteredDevices" :key="device._id" class="result">
                    <td>{{ device.nickname }}</td>
                    <td>{{ device.version }}</td>
                    <td>{{ device.ip }}</td>
                    <td>{{ this.formatDate(device.lastConnect) }}</td>
                    <td>
                        <router-link :to="'/activities?device=' + device._id" >Activity</router-link>
                    </td>
                </tr>
            </table>

            <div class="">
                <router-link :to="'/activities' + buildDevicesQuery()" >All devices activity for user</router-link>
            </div>
        </OverlayModal>
    </div>
</template>

<script>
import OverlayModal from '@/components/global/OverlayModal'

export default {
    name: 'DevicesModal',
    props: ['userId', 'devices'],
    components: {
        OverlayModal
    },
    data: function() {
        return {
            filteredDevices: this.devices,
            devicesCounter: this.devices.length,

            searchQuery: ''
        }
    },
    created() {
        this.sortDevices()
    },
    watch: {
        searchQuery(newValue) {
            if (newValue === '') {
                this.filteredDevices = this.devices
                return
            }
            this.filteredDevices = this.searchInDevices(newValue)
        }
    },
    methods: {
        sortDevices() {
            this.filteredDevices.sort((a, b) => {
                return new Date(b.lastConnect) - new Date(a.lastConnect)
            })
        },
        buildDevicesQuery() {
            let query = '?dummy=1'
            for (let i = 0; i < this.devices.length; i++) {
                query += '&device=' + this.devices[i]._id
            }
            return query
        },
        searchInDevices(query) {
            let filteredResults = []
            for (let i = 0; i < this.devices.length; i++) {
                if (this.devices[i].nickname.toLowerCase().includes(query.toLowerCase())) {
                    filteredResults.push(this.devices[i])
                }
            }
            return filteredResults
        },
        clearSearch() {
            this.searchQuery = ''
            document.getElementById('search-input').focus()
        },
        /*
        openAddLibrary() {
            this.librariesModalOpen = true
        },
        */
        closeModal() {
            this.$emit('modalClosed', false)
        }
    }
}
</script>

<style lang="scss">
.form-control {
    width: 100%;
    border-radius: 5px;
    padding: 5px 10px;
    box-sizing: border-box;
}

.results {
    max-height: 500px;
    width: 100%;
    overflow-y: auto;
    overflow-x: auto;
    background: #eee;
    border-spacing: 0;
    border-collapse: collapse;

    th {
        text-align: left;
    }
    th, td {
        border: 1px solid #aaa;
        padding: 2px 5px;
    }
}

.search-input-holder {
    position: relative;
    box-sizing: border-box;

    .clear-search-btn {
        position: absolute;
        right: 15px;
        top: 3px;
    }
}
</style>
